
import { useEffect, useState } from "react";
import Sider from "../../comps/sider/main";
import './main.css';
import { Link, useSearchParams } from 'react-router-dom';
import callAPI from "../../comps/fetch/main";
import ShowPlans from "../../comps/show_plans/main";
import { Alert, Skeleton, Card, message, Col, Row, Statistic, Tooltip, Empty, Button, Collapse, Popover, Divider, Modal, Segmented, Tag, Space, Tabs } from "antd";
import { RightCircleOutlined, VideoCameraOutlined, HistoryOutlined, PlusSquareOutlined, PlusCircleOutlined, StepForwardOutlined, FastForwardOutlined } from '@ant-design/icons';
import { useLocation, useNavigate } from "react-router-dom";
import AccessOrNot from "../../funcs/accessOrNot";

function Home() {

  const navigate = useNavigate();
  const [loading, setLoading] = useState()
  const [data, setData] = useState()

  const [loadingAutomated, setLoadingAutomated] = useState()
  const [dataAutomated, setDataAutomated] = useState({ data: undefined })

  const [dataAutomatedFormated, setDataAutomatedFormated] = useState({})
  const [loadMore, setLoadMore] = useState(false)

  const [oldData, setOldData] = useState([])
  const [messageApi, contextHolder] = message.useMessage();

  const [postsError, setPostsError] = useState(undefined)

  const [totalCredits, setTotalCredits] = useState()

  let user_tz = Intl.DateTimeFormat().resolvedOptions().timeZone

  const [userUsage, setUserUsage] = useState({ "monthly_count": "" })
  const [accountViral, setAccountViral] = useState({})
  const [loadingUserUsage, setLoadingUserUsage] = useState(true)

  const [selectedCategory, setSelectedCategory] = useState('posts')

  const [showPlanModal, setShowPlanModal] = useState(false)

  const [statusError, setStatusError] = useState(false)

  useEffect(() => {
    const token = localStorage.getItem("token")
    if (token == undefined) {

      navigate("/signup")
    }
    setLoadMore(true)
  }, [])

  useEffect(() => {
    if (postsError != undefined) {
      messageApi.open({
        type: 'error',
        content: postsError,
        duration: 15,
        key: 2
      })
    }
  }, [postsError])

  useEffect(() => {


    if (loadingUserUsage == true) {
      return
    }

    setAccountViral({ "reason_notify": userUsage?.automation_setting?.reason_notify || {} })
    setUserUsage({ "monthly_count": userUsage?.data?.monthly_count })

  }, [loadingUserUsage])

  const [userPlan, setUserPlan] = useState()
  const [userPlanLoading, setUserPlanLoading] = useState(true)

  useEffect(() => {

    let tempData = {}
    if (dataAutomated["data"] == undefined) {
      return
    }

    dataAutomated["data"].map((item) => {
      tempData[item.post_id] = item.automated_segment.length > 0 ? true : false
    })

    setDataAutomatedFormated(tempData)
    let apiURL = `ig-usage-stat?tz=${user_tz}`
    callAPI({ url: apiURL, method: "GET", loadingState: setLoadingUserUsage, dataState: setUserUsage })

    let apiURL2 = `user_plan`
    callAPI({ url: apiURL2, method: "GET", loadingState: setUserPlanLoading, dataState: setUserPlan })



  }, [dataAutomated])


  useEffect(() => {

    if (userPlan == undefined) {
      return
    }
    if (userPlan?.data == undefined) {
      return
    }
    if (userPlan?.data != undefined) {
      let copy_data = { ...userPlan }

      let credit = Number(copy_data?.data?.plan_credits) + Number(copy_data?.data?.topup_credit)

      setTotalCredits(credit)
      localStorage.setItem("planid", userPlan.data.plan_details.id)
      localStorage.setItem("founding_user", userPlan.data.founding_user)
      setUserPlan({ ...userPlan.data })

      return
    }

  }, [userPlan])

  useEffect(() => {
    messageApi.destroy(1)

    if (data != undefined && oldData.length < 1) {
      // On every inital load
      if (data.fb_api != undefined) { localStorage.setItem("fb_api", data.fb_api) }
      if (data.ig_api != undefined) { localStorage.setItem("ig_api", data.ig_api) }
    }

    if (oldData.length < 1 || data == undefined) {
      return
    }

    if (data?.code != 200) {
      setStatusError(true)
      return
    }
    if (data?.code == 200) {
      setStatusError(false)
    }

    let oldDataTemp = [...oldData]
    setOldData([])

    console.log("=====DATATATA=====", data)
    if (data?.posts_lists?.error != undefined) {
      setPostsError(data.posts_lists.error.message)
    }

    if (data.posts_lists.data != undefined) {

      setData({ ...data, posts_lists: { ...data.posts_lists, data: [...oldDataTemp, ...data.posts_lists.data] } })
    }



    setStatusError(false)


  }, [data])

  useEffect(() => {
    if (loading == true) {
      return
    }
    if (loadMore == false) {
      return
    }
    messageApi.open({
      type: 'loading',
      content: 'Loading your posts',
      duration: 0,
      key: 1
    });

    let apiURL = ""

    if (selectedCategory == "posts") {
      apiURL = "ig-posts"
    }
    if (selectedCategory == "stories") {
      apiURL = "ig-stories"
    }

    if (selectedCategory == "next-post") {
      apiURL = "next-post"
    }
    // let old_data = []

    console.log("API going to call")
    if (data?.posts_lists?.paging?.cursors?.after) {
      apiURL += `?after=${data?.posts_lists?.paging?.cursors?.after}`
      if (data.posts_lists.data != undefined) {
        setOldData([...data.posts_lists.data])
      }

    }

    callAPI({ url: apiURL, method: "GET", loadingState: setLoading, dataState: setData })

    if (dataAutomated.data == undefined) {
      let apiAutmatedURL = `automate-post`
      callAPI({ url: apiAutmatedURL, method: "GET", loadingState: setLoadingAutomated, dataState: setDataAutomated })
    }


    setLoadMore(false)


  }, [loadMore])

  useEffect(() => {

    setData()
    setLoadMore(loadMore == undefined ? true : undefined)


  }, [selectedCategory])




  const [paymentLinkData, setPaymentLinkData] = useState()
  const [paymentLinkLoading, setPaymentLinkLoading] = useState()

  const [showINR, setShowINR] = useState((user_tz == "Asia/Kolkata" || user_tz == "Asia/Calcutta") ? true : false)

  const [showWaitingPaymentUpdate, setShowWaitingPaymentUpdate] = useState(false)
  const [showWaitingPaymentFailed, setShowWaitingPaymentFailed] = useState(false)

  const [showWhatsNew, setShowWhatsNew] = useState(false)

  let release_id = "release_30122024"

  useEffect(() => {


    if (paymentLinkData?.payment_url == undefined) {
      return
    }

    messageApi.destroy("payment-process")


    if (!showINR && window.LemonSqueezy) {
      const checkoutUrl = paymentLinkData.payment_url
      window.LemonSqueezy.Url.Open(checkoutUrl);
    }

    if (showINR && window.Razorpay) {

      try {

        const options = {
          key: "rzp_live_JtjGCHjkESNzIZ", // Replace with your Razorpay key
          name: "InstantDM",
          description: "Affordable Comment to DM automation tool",
          subscription_id: paymentLinkData.rzpy_sub_id, // Order ID from your server (generated by your backend)
          handler: function (response) {
            setShowPlanModal(false)
            setShowWaitingPaymentUpdate(true)
            setPaymentLinkData({})
            // alert("Payment Successful: " + response.razorpay_payment_id);
          },
          error: function (response) {
            setShowPlanModal(false)
            setShowWaitingPaymentFailed(true)
            setPaymentLinkData({})
            // alert("Payment Failed: " + response.error.description);
          },
          prefill: {
            name: paymentLinkData.customer_name,
            email: paymentLinkData.customer_email,
          },
          "notes": paymentLinkData.notes != undefined ? { ...paymentLinkData.notes } : {},
          theme: {
            color: "#1677ff",
          },
          display: {
            handler: function () {
              return {
                "offers": [
                  {
                    "type": "discount",
                    "description": "10% discount on first purchase",
                    "amount": 100
                  },
                  {
                    "type": "coupon",
                    "description": "Rs. 100 off on total bill",
                    "code": "INSTANT10"
                  }
                ]
              }
            }
          },
        };

        const razorpayInstance = new window.Razorpay(options);
        razorpayInstance.open();

      } catch (error) {
        alert("Error loading Razorpay: " + error.message);
      } finally {
        // setLoading(false);
      }

    }

    else {
      message.error("Please try again later...")
    }



  }, [paymentLinkData])

  function planContent() {

    if (userPlan == undefined) {
      return <p>Loading</p>
    }
    return (
      <div>

        <Statistic
          title="Plan credits"
          value={userPlan?.plan_credits}
          // precision={2}
          valueStyle={{
            color: 'black',
            fontWeight: '600'
          }} />

        <Statistic
          title="Topup credits"
          value={userPlan?.topup_credit}
          // precision={2}
          valueStyle={{
            color: 'black',
            fontWeight: '600'
          }} />

        {userPlan?.plan_details?.id == "free" && <Button type="primary" style={{ marginTop: '10px' }} onClick={() => { userPlan?.plan_details?.id == "free" && setShowPlanModal(true) }}>
          Upgrade to paid plan
        </Button>
        }

        {/* <Button type="primary" style={{marginTop:'10px'}} onClick={() => {userPlan?.plan_details?.id == "free" ? setShowPlanModal(true) : createPaymentLink("topup",messageApi, setPaymentLinkLoading, setPaymentLinkData) }}>
              { userPlan?.plan_details?.id == "free" ? "Upgrade to paid plan" : "Buy more credits"}
            </Button> */}

      </div>
    )
  }





  // console.log("========CREDIT=====" , totalCredits)
  return (
    <div className="page-layout">
      {contextHolder}

      <Sider />
      <div className="page-content">

      <Alert
                message="New plan - Trendsetter"
                description="🚀 Introducing our Trendsetter Plan: higher rate limits, auto slow-down mode, auto comment toggle, and personalized welcome messages! 🔥 Upgrade now and unlock more features to boost your account saftey and viral! 💥"
                type="info"
                style={{ marginBottom: '10px', marginTop: '10px' }}
                action={
                  <Button size="large" type="primary" onClick={() => { setShowPlanModal(true) }}>
                    Show Plans
                  </Button>
                }
                showIcon
                />


        {/* {localStorage.getItem(release_id) != "true" && <Alert
          message="🎉 See what's new !!! Followers only & Seprate Credits for stories automation and followers only."
          description=""
          type="info"
          style={{ marginBottom: '10px', marginTop: '10px' }}
          showIcon
          action={
            
             <Space direction="horizontal" size="large">
              
              <Button   type="primary" onClick={() => setShowWhatsNew(true)} >
                See what's new 🎉
              </Button>

              <Button size="small" danger ghost onClick={() => localStorage.setItem(release_id, "true")  }>
                Close
              </Button>
              
            </Space>
            
          }
        />

        } */}


        {showWaitingPaymentUpdate && <Alert
          message="Yay!! We have received your payment!"
          description="We have received your payment. Please give us a moment while we verify your payment details. Thank you."
          type="warning"
          style={{ marginBottom: '10px', marginTop: '10px' }}
          icon="🙏"
          showIcon
          closable
        />

        }
        {
          accountViral?.reason_notify?.title != undefined &&
          <Alert
            message={accountViral?.reason_notify?.title}
            description={accountViral?.reason_notify?.message}
            style={{ marginBottom: '10px', marginTop: '10px' }}
            type={accountViral?.reason_notify?.title.toLowerCase().includes("stopped") ? "error" : accountViral?.reason_notify?.title.toLowerCase().includes("viral") ? "success" : "info"}
            showIcon

          />
        }

        {showWaitingPaymentFailed && <Alert
          message="We're very sad that payment didn't go through well!"
          description="We have noticed that your payment was unsuccessful, please wait for sometime and try again, or contact our team for support, @instant.dm via instagram ."
          type="warning"
          style={{ marginBottom: '10px', marginTop: '10px' }}
          icon="🙏"
          showIcon
          closable
        />
        }

        {(userPlan?.sub_status != undefined && userPlan?.sub_status != "active" && userPlan?.plan_details?.id != "free") && <Alert
          message="Subscription Expired"
          description="Ohho no, you're supscription expired, please renew to continue"
          type="error"
          style={{ marginBottom: '10px', marginTop: '10px' }}
          action={
            <Button size="large" type="primary" onClick={() => { setShowPlanModal(true) }}>
              Renew Subscription
            </Button>
          }
          showIcon />
        }

        {(totalCredits != 0 && userPlan?.plan_details?.id == "free") && <Alert
          message="Free Plan"
          description="You're currently on free plan, click here to upgrade your plan."
          // type="error"
          style={{ marginBottom: '10px', marginTop: '10px' }}
          action={
            <Button size="large" type="primary" onClick={() => { setShowPlanModal(true) }}>
              Show Plans
            </Button>
          }
          showIcon />
        }

        {(totalCredits < 1 && userPlan?.plan_details?.id == "free") && <Alert
          message="Automation Stoped!"
          description="You have reached your monthly free usage limit. To continue using our automation services, please consider upgrading to a paid plan."
          type="error"
          style={{ marginBottom: '10px', marginTop: '10px' }}
          action={
            <Button size="large" type="primary" onClick={() => { setShowPlanModal(true) }}>
              Show Plans
            </Button>
          }
          showIcon />
        }

        {/* {(totalCredits < 1 && userPlan?.plan_details?.id != "free") &&  <Alert
                  message="Automation Stoped!"
                  description="You have used all of your credits, please buy more credits to continue"
                  type="error"
                  style={{marginBottom:'10px', marginTop:'10px'}}
                  action={
                    <Button size="large" type="primary" onClick={() => {createPaymentLink("topup",messageApi, setPaymentLinkLoading, setPaymentLinkData)}}>
                      Buy Credits
                    </Button>
                  }
                  showIcon />
                } */}

        {(totalCredits < 1 && userPlan?.plan_details?.id != "free") && <Alert
          message="Automation Stoped!"
          description="We're stoked your account is getting more traction, but unfortunately, you've used up all your credits. Can you switch to a new plan so automation can start working again?"
          type="error"
          style={{ marginBottom: '10px', marginTop: '10px' }}
          action={
            <Button size="large" type="primary" onClick={() => { setShowPlanModal(true) }}>
              Show Plans
            </Button>
          }
          showIcon />
        }

        {/* { (totalCredits  > 0 && totalCredits <= 100) && <Alert
                  message="Low on credits!"
                  description={` Only ${Number(userPlan?.plan_credits) + Number(userPlan?.topup_credit)} credits left, You're low on credits, you automation will stop once you're out credits.`}
                  type="warning"
                  style={{marginBottom:'10px', marginTop:'10px'}}
                  action={
                    <Button size="large" type="primary" onClick={() => {createPaymentLink("topup",messageApi, setPaymentLinkLoading, setPaymentLinkData)}}>
                      Buy Credits
                    </Button>
                  }
                  showIcon
                  closable />
                } */}

        <div className="home-sec-1">


          <Tabs defaultActiveKey="1" items={[

            {
              "key": "1",
              "label": "Post Automation",
              children: <>
                <div className="mobile usage-content usage-content-mobile" style={{ marginTop: '0px' }}>
                  <Tooltip title="Automated Comments for This Month">

                    <Statistic
                      title="Monthly Automated"
                      value={userUsage.monthly_count || "Loading..."}
                      // precision={2}
                      valueStyle={{
                        color: 'black',
                        fontWeight: '600'

                      }}
                      style={{ width: '40%' }}
                    />


                  </Tooltip>
                  <div style={{ height: '80px', width: '2px', backgroundColor: 'grey', opacity: '.2' }} />

                  <Popover content={planContent} title="Credits Detail">

                    <Statistic title="Available credits" value={userPlan?.plan_credits != "unlimited" ? totalCredits : userPlan?.plan_credits} style={{ width: '40%' }} />

                  </Popover>



                </div>
                <div className="home-title-div">

                  <div className="title-content">
                    <h1>Automate your posts</h1>

                  </div>

                  <div className="desktop usage-content">


                    <Tooltip title="Automated Comments for This Month">

                      <Col>

                        <Statistic
                          title="Monthly Automated"
                          value={userUsage.monthly_count || "Loading..."}
                          // precision={2}
                          valueStyle={{
                            color: 'black',
                            fontWeight: '600'
                          }} />

                      </Col>


                    </Tooltip>

                    <div style={{ height: '80px', width: '2px', backgroundColor: 'grey', opacity: '.2' }} />

                    <Popover content={planContent} title="Credits Detail">
                      <Col>
                        <Statistic title="Available credits" value={userPlan?.plan_credits != "unlimited" ? totalCredits : userPlan?.plan_credits} />
                      </Col>

                    </Popover>



                  </div>

                </div>
                <Segmented
                style={{marginBottom:'20px'}}
                  options={[
                    {
                      label: <p style={{ color: selectedCategory == "posts" ? "blue" : "black" }}><VideoCameraOutlined /> Posts </p>,
                      value: 'posts',
                    },
                    {
                      label: <p style={{ color: selectedCategory == "stories" ? "blue" : "black" }}><HistoryOutlined /> Stories </p>,
                      value: 'stories',
                    },
                    {
                      label: <p style={{ color: selectedCategory == "next-post" ? "blue" : "black" }}><PlusSquareOutlined /> Next Automation </p>,
                      value: 'next-post',
                    },
                  ]}

                  onChange={(value) => { setSelectedCategory(value) }}
                />


                {
                  data?.show_ig_connect == true &&

                  <Empty
                    style={{ marginBottom: '200px' }}
                    imageStyle={{
                      height: 60,
                    }}
                    description={
                      <p style={{ width: '60%', margin: '0 auto', fontSize: '16px' }}>
                        Reconnect your IG account to use this feature.
                        <br />
                      </p>
                    }
                  >
                    <Button type="primary" danger> <a href="/ig-connect?show_ig_connect=true">Re-connect your IG account</a></Button>
                  </Empty>
                }



                {
                  (data?.posts_lists?.data != undefined && (data?.posts_lists?.data || []).length < 1) &&

                  <Empty
                    style={{ marginTop: '20px' }}
                    imageStyle={{
                      height: 60,
                    }}
                    description={
                      <p style={{ width: '60%', margin: '0 auto', fontSize: '16px' }}>
                        {selectedCategory == "stories" && `Looks like no active story posted!`}
                        {selectedCategory == "next-post" && `Looks like you haven't created any next automation.`}
                        {selectedCategory == "posts" && `Looks like no post published!`}
                        <br />
                      </p>
                    }
                  >

                  </Empty>
                }


                {
                  selectedCategory == "next-post" &&

                  <div style={{ marginBottom: '30px' }}>
                    <h1>Next post automation</h1>
                    <p style={{ opacity: '.6' }}>Automate your next post before uploading to Instagram! Save time, effort, and never lose engagement.</p>
                  </div>
                }

                {
                  (data?.posts_lists?.data != undefined && selectedCategory == "next-post") &&
                  <div className="posts-list" style={{ marginBottom: '60px' }}>



                    {
                      data["posts_lists"].data.length < 2 &&
                      <Link style={{ textDecoration: 'none' }} key={data["posts_lists"].data.length > 0 ? Number(data["posts_lists"].data.at(-1).temp_post_id || "0") + 1 : 1} to={`manage-post/${data["posts_lists"].data.length > 0 ? Number(data["posts_lists"].data.at(-1).temp_post_id || "0") + 1 : 1}?post_type=${selectedCategory}`}>
                        <div className="next-post-add">
                          <PlusCircleOutlined className="arrow-icon" />
                          <p>Create next post automation</p>
                        </div>
                      </Link>
                    }

                    {data?.posts_lists.data.map((post, index) =>
                      post.temp_post_id != undefined &&
                      <Link style={{ textDecoration: 'none' }} key={post.temp_post_id} to={`manage-post/${post.temp_post_id}?post_type=${selectedCategory}`}>
                        <div className="next-post-add">
                          {index == 0 ? <StepForwardOutlined className="arrow-icon" /> : <FastForwardOutlined className="arrow-icon" />}
                          <p>{`Next post #${index + 1}`}</p>
                        </div>
                      </Link>

                    )}

                  </div>
                }



                {
                  (data?.posts_lists?.data != undefined && selectedCategory != "next-post") &&

                  <div className="posts-list">
                    {data["posts_lists"]["data"].map((post) => {
                      return (
                        <Link style={{ textDecoration: 'none' }} key={post.id} to={`manage-post/${post.id}?post_type=${selectedCategory}`}><div className="post">
                          <img alt={post.caption} style={{ minWidth: '140px', maxWidth: '100%' }} className="thumbnil-img" src={`https://imagecorsworkers.sanjayhotaction.workers.dev/${post.thumbnail_url || post.media_url}`} crossorigin="anonymous" />

                          {dataAutomatedFormated[post.id] == true ?
                            <div className="automate-label automated">
                              <p>Automated</p>
                            </div>
                            :
                            <div className="automate-label not-automated">
                              <p>Not Automated</p>
                            </div>}
                        </div>
                        </Link>)
                    })}
                    {
                      loadMore != true && (data?.posts_lists?.paging?.cursors?.after != undefined) &&
                      <div className="load-more" onClick={() => { setLoadMore(true) }}>
                        <RightCircleOutlined className="arrow-icon" />
                        <p>Load more</p>
                      </div>
                    }
                  </div>
                }

                {
                  // data?.fb_api != undefined && data?.fb_api != true  &&
                  (data?.fb_api != undefined && data?.fb_api != true && selectedCategory == "next-post") &&

                  <div className="fb-connect-card" style={{ marginBottom: '100px' }}>
                    <h1>To automatically map your next post, link your Instagram and Facebook pages. Once linked, connect your account by tapping the button below. Watch video for better understanding.</h1>
                    <a href="/ig-connect"> <Button type="primary" size="large" block>[Re]connect your FB page</Button> </a>
                    {/* <Button style={{marginTop:'20px'}} size="large" block>How this works, Watch 1 minute video.</Button> */}

                  </div>
                }

                {
                  selectedCategory == "next-post" &&

                  <iframe width="315" height="560"
                    style={{ margin: "0 auto" }}
                    src="https://www.youtube.com/embed/zIRW-Y3_ow0"
                    title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowfullscreen></iframe>


                }


                {(loading || loadMore && selectedCategory != "next-post") && <div className="posts-list">
                  {
                    Array(10).fill(0).map((_, index) => (
                      <Skeleton.Button
                        key={index}
                        style={{
                          width: 150,
                          height: 260,
                          borderRadius: '20px',
                          margin: '10px'
                        }}
                        active
                      />
                    ))
                  }
                </div>}

                {
                  (((data?.posts_lists == undefined || data?.posts_lists?.error != undefined) && loading == false) && selectedCategory != "next-post") &&

                  <Empty

                    imageStyle={{
                      height: 60,
                    }}
                    description={
                      <p style={{ width: '60%', margin: '0 auto', color: 'red', fontSize: '16px' }}>
                        Connect / Re-connect your IG account to continue automation.
                        <br />
                        <Collapse style={{ marginTop: '20px' }} items={[{ "key": 1, "label": "Click for more details", "children": <p>{data?.posts_lists?.error?.message || "Don't worry about your previous automation, the configuration are stored in secure way. Try reconnecting your account."}</p> }]} />
                      </p>


                    }
                  >
                    <div style={{ display: 'flex', width: '30%', minWidth: '240px', maxWidth: '90%', margin: '0 auto', flexDirection: 'column', 'gap': '20px', alignContent: 'center', justifyContent: 'center', paddingBottom: '60px' }}>
                      <a href={selectedCategory == "stories" ? "/ig-connect?show_ig_connect=true" : "/ig-connect"}><Button type="primary" danger> Re-connect your IG account</Button></a>
                      {/* <Button type="primary"> <Link to="/oia">Use Open in Link / URL Shortner </Link> </Button> */}
                    </div>
                  </Empty>
                }


              </>
            },
            // {
            //   "key": "2",
            //   "label": "DM & Account automation",
            //   "children": 
            // },
          ]} />


        </div>

      </div>

      <Modal
        title="Plans"
        open={showPlanModal}
        onCancel={() => setShowPlanModal(false)}
        width='90%'
        maxWidth='800px'
      >


        <ShowPlans messageApi={messageApi} setPaymentLinkLoading={setPaymentLinkLoading} setPaymentLinkData={setPaymentLinkData} currentPlan={localStorage.getItem("planid")} />
      </Modal>


    </div>
  )

}
export default Home;
